<div class="table-container">
  <app-scroll-view
    class="scroll-view"
    [vertical]="false"
    [horizontal]="true"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  >
    <table class="table-results" mat-table [dataSource]="_pagedData">
      <ng-container matColumnDef="actions" *ngIf="!!showSelectControlsEnabled">
        <th mat-header-cell *matHeaderCellDef class="table-header-cell"></th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          class="table-cell actions-column"
        >
          <div class="actions-column-content">
            <app-check-box
              class="checkbox"
              [value]="isElementSelected(i)"
              (valueChange)="setElementSelected(i, $event)"
            ></app-check-box>

            <div #btnZoomToEl class="btn-item">
              <app-button
                buttonType="normal"
                styleType="text"
                sizeType="small"
                shapeType="circle"
                icon="assets/icons/location-arrow.svg"
                (click)="onBtnZoomToClick(i)"
              ></app-button>

              <app-tooltip
                [target]="btnZoomToEl"
                verticalAlignment="top"
                horizontalAlignment="center"
              >
                Ver no mapa
              </app-tooltip>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container
        matColumnDef="{{ field.name }}"
        *ngFor="let field of fields"
      >
        <th mat-header-cell *matHeaderCellDef class="table-header-cell">
          {{ field.alias ?? field.name }}
        </th>
        <td mat-cell *matCellDef="let element" class="table-cell">
          <ng-template
            [ngTemplateOutlet]="itemValueTpl"
            [ngTemplateOutletContext]="{
              field,
              value: getValue(field, element)
            }"
          ></ng-template>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="table-header"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
      ></tr>
    </table>
  </app-scroll-view>
</div>

<div class="pagination-row">
  <app-pagination
    [totalCount]="resultList?.length ?? 0"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    (pageIndexChange)="onPageIndexChange($event)"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-pagination>
</div>

<ng-template #itemValueTpl let-field="field" let-value="value">
  <ng-container [ngSwitch]="field?.type">
    <ng-container *ngSwitchCase="'date'">
      {{ value | async | date: "dd/MM/yyyy HH:ss:mm" }}
    </ng-container>

    <ng-container *ngSwitchDefault>
      {{ value | async }}
    </ng-container>
  </ng-container>
</ng-template>
